// extracted by mini-css-extract-plugin
module.exports = {"carregador":"Carregador_carregador__3duAL","icone":"Carregador_icone__2xiOA","small":"Carregador_small__2bdYs"};